module.exports = __webpack_public_path__ + "static/zyppyslandingimg-d136fd7f7239d91ad0efe28dc553cdf0.jpg";